import { Controller } from "@hotwired/stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {
  static values = {
    options: Object,
  };

  connect() {
    const defaultOptions = {
      type: "slide",
      autoWidth: true,
      gap: "24px",
      pagination: false,
      arrows: false,

      drag: true,
      snap: true,
      perMove: 1,

      speed: 600,

      autoplay: false,
      interval: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,

      trimSpace: false,
      rewind: false,

      breakpoints: {
        768: {
          gap: "12px",
        },
      },
    };

    const options = {
      ...defaultOptions,
      ...(this.optionsValue || {}),
    };

    requestAnimationFrame(() => {
      this.splide = new Splide(this.element, options);
      this.splide.mount();

      this.element.splide = this.splide;

      setTimeout(() => {
        this.splide.refresh();
      }, 0);
    });

    this.bindArrows();
  }

  bindArrows() {
    const wrapper = this.element.closest(".gv-splide-slider-container");
    if (!wrapper) return;

    this.prevButton = wrapper.querySelector(".gv-splide-prev");
    this.nextButton = wrapper.querySelector(".gv-splide-next");

    this.handlePrev = () => this.splide?.go("<");
    this.handleNext = () => this.splide?.go(">");

    this.prevButton?.addEventListener("click", this.handlePrev);
    this.nextButton?.addEventListener("click", this.handleNext);
  }

  disconnect() {
    this.prevButton?.removeEventListener("click", this.handlePrev);
    this.nextButton?.removeEventListener("click", this.handleNext);

    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }

  // OPTIONAL (very useful for your AJAX case)
  refresh() {
    if (this.splide) {
      this.splide.refresh();
    }
  }
}